import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { setTabToken } from '../../../shared/services/token';

const API = `${process.env.REACT_APP_API_URL || 'https://recruitai.pingitright.com/api'}/platform`;

/**
 * Lands in the NEW tab and turns a company id into a session for this tab only.
 *
 * The token is minted here rather than passed in from the opener, so it never
 * appears in a URL, in browser history, or in a referrer header. This page
 * authenticates with the platform token from localStorage — which it can still
 * read, because the impersonated token goes to sessionStorage instead.
 */
export default function ImpersonateHandoff() {
  const { companyId } = useParams();
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const platformToken = localStorage.getItem('recruit_token');
        if (!platformToken) throw new Error('Your platform session has expired. Sign in again.');

        const res = await fetch(`${API}/companies/${companyId}/login-as`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${platformToken}`, 'Content-Type': 'application/json' },
        });
        const d = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(d.detail || 'Could not sign in as this company.');

        // sessionStorage, so the tab that opened this one keeps its platform session.
        setTabToken(d.token);
        try {
          sessionStorage.setItem('recruit_impersonating', d.company?.name || 'a customer account');
        } catch { /* label is cosmetic */ }

        window.location.replace('/');
      } catch (e) {
        setError(e.message);
      }
    })();
  }, [companyId]);

  const wrap = {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    height: '100vh', fontFamily: 'system-ui, sans-serif',
    color: 'var(--text-muted, #6b7280)', fontSize: 14, textAlign: 'center', padding: 24,
  };

  if (error) {
    return (
      <div style={wrap}>
        <div>
          <AlertTriangle size={26} strokeWidth={1.6} color="#b42318" />
          <div style={{ marginTop: 10, color: '#b42318' }}>{error}</div>
          <button
            onClick={() => window.close()}
            style={{
              marginTop: 18, padding: '8px 16px', fontSize: 13, fontWeight: 600,
              borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer',
            }}
          >
            Close tab
          </button>
        </div>
      </div>
    );
  }

  return <div style={wrap}>Signing you in…</div>;
}
